export const FETCH_FEE_SHIP_SUCCESS = "FETCH_FEE_SHIP_SUCCESS";
